import { Dialog } from "@dash/dialog";
import { useDeviceType } from "@dash/mq";
import type { MessageAttachmentSummaryDto } from "@megaron/support-contracts";
import type { Uuid } from "@megaron/uuid";
import { Fragment, useState } from "react";

import { SupportTicketAttachmentExpanded } from "./SupportTicketAttachmentExpanded";
import { SupportTicketAttachmentTile } from "./SupportTicketAttachmentTile";

type Props = {
  ticketId: Uuid;
  messageId: Uuid;
  attachments: MessageAttachmentSummaryDto[];
};

export function SupportTicketMessageAttachments({ ticketId, messageId, attachments }: Props) {
  const { isMobile } = useDeviceType();
  const [expandedId, setExpandedId] = useState<Uuid | null>(null);

  const expandedSummary =
    expandedId !== null && attachments.length > 0 ? attachments.find((a) => a.id === expandedId) : undefined;

  if (attachments.length === 0) return null;

  const activate = (id: Uuid) => {
    setExpandedId((current) => (current === id ? null : id));
  };

  return (
    <Fragment>
      <div css={{ marginTop: "0.75rem" }}>
        <div css={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
          {attachments.map((attachment) => (
            <SupportTicketAttachmentTile
              key={attachment.id}
              ticketId={ticketId}
              messageId={messageId}
              summary={attachment}
              isSelected={expandedId === attachment.id}
              onActivate={() => activate(attachment.id)}
            />
          ))}
        </div>
      </div>
      {expandedSummary && (
        <Dialog
          onClose={() => setExpandedId(null)}
          placement={isMobile ? "fullscreen" : undefined}
          header={expandedSummary.fileName}
          css={{
            width: isMobile ? undefined : "min(920px, calc(100vw - 3rem))",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <SupportTicketAttachmentExpanded ticketId={ticketId} messageId={messageId} summary={expandedSummary} />
        </Dialog>
      )}
    </Fragment>
  );
}
